import mask from 'slim-mask-js'

function formatCpf(cpf) {
  return mask(cpf, '###.###.###-##')
}
function formatCnpj(cnpj) {
  return mask(cnpj, 'XX.XXX.XXX/XXXX-##')
}

export default function documentNumberMask(str) {
  if (!str) return ''
  const string = String(str).replace(/[^A-Z0-9]/gi, '').toUpperCase()
  if (string.length <= 11) return formatCpf(string)

  return formatCnpj(string)
}
